import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { GroupPickerComponent } from './group-picker.component';
import { InputTextModule } from 'primeng/inputtext';



@NgModule({
  declarations: [GroupPickerComponent],
  imports: [
    CommonModule,
    TreeModule,
    ButtonModule,
    MessageModule,
    MenuModule,
    TableModule,
    InputTextModule
  ],
  exports: [GroupPickerComponent]
})
export class GroupPickerModule { }
